import { Injectable } from '@angular/core';
import { TranslocoLoader } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly cache = new Map<string, any>();

  constructor(private readonly http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    if (this.cache.has(lang)) {
      return new Observable(observer => {
        observer.next(this.cache.get(lang));
        observer.complete();
      });
    }

    const translationFiles = this.getTranslationFilesForLang(lang);

    return forkJoin(translationFiles).pipe(
      map(translations => {
        const combinedTranslations = translations.reduce((acc, curr) => ({ ...acc, ...curr }), {});
        
        this.cache.set(lang, combinedTranslations);
        
        return combinedTranslations;
      })
    );
  }

  private getTranslationFilesForLang(lang: string): Observable<any>[] {
    const files = [
      `../../i18n/${lang}.json`,
    ];

    return files.map(file => this.http.get(file));
  }
}
